import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

const PUBLIC_URL = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
const TRANSLATION_VERSION =
  process.env.REACT_APP_TRANSLATION_VERSION || Date.now();

try {
  const savedLanguage = window.localStorage.getItem("i18nextLng");
  const normalizedLanguage = savedLanguage
    ? savedLanguage.split("-")[0].toLowerCase()
    : null;

  if (
    savedLanguage &&
    normalizedLanguage &&
    !["it", "en"].includes(normalizedLanguage)
  ) {
    window.localStorage.setItem("i18nextLng", "en");
  }
} catch (error) {
  console.warn("Impossibile leggere la lingua salvata:", error);
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: "en",
    supportedLngs: ["en", "it"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    cleanCode: true,

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },

    backend: {
      // The CI sets the version to the commit SHA, so each deploy gets fresh
      // copy while repeat visits can reuse the browser cache.
      loadPath: `${PUBLIC_URL}/locales/{{lng}}/translation.json?v=${TRANSLATION_VERSION}`,
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;